import { TW_TCAT_HOME_DELIVERY_TYPE } from '../constants/delivery';

app.service('tcatService', function () {
  return {
    isTcatHomeDeliveryType: function (regionType) {
      return Object.values(TW_TCAT_HOME_DELIVERY_TYPE).includes(regionType);
    },
  };
});
